module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 1803
// module chunks = 0